import React from 'react';
import { Row, Col } from '../../lib/utils';
import { DemiLightText, MediumText } from '../../lib/Text';
import { colors } from '../../lib/colors';
import SvgIcon from '../SvgIcon';

type TabLockPromotionTooltipProps = {
    onClickSetup: () => void;
    onDismiss: () => void;
};

const TabLockPromotionTooltip: React.FC<TabLockPromotionTooltipProps> = ({ onClickSetup, onDismiss }) => {
    return (
        <div
            className="absolute top-full mt-[12px] right-0 z-50"
            style={{ animation: 'fadeSlideIn 0.3s ease-out' }}
        >
            {/* 말풍선 화살표 */}
            <div
                style={{
                    position: 'absolute',
                    top: -6,
                    right: 40,
                    width: 12,
                    height: 12,
                    backgroundColor: 'white',
                    transform: 'rotate(45deg)',
                    boxShadow: '-2px -2px 4px rgba(0, 0, 0, 0.04)',
                }}
            />
            <Col
                style={{
                    width: 300,
                    backgroundColor: 'white',
                    borderRadius: 12,
                    padding: '16px 20px',
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                    position: 'relative',
                }}
            >
                {/* 닫기 버튼 */}
                <div
                    onClick={onDismiss}
                    style={{
                        position: 'absolute',
                        top: 10,
                        right: 12,
                        cursor: 'pointer',
                        padding: '2px 6px',
                        borderRadius: 4,
                        fontSize: 14,
                        color: '#8E9AA0',
                        lineHeight: 1,
                    }}
                    className="hover:bg-[#F2F4F6] transition-colors"
                >
                    ✕
                </div>

                {/* 아이콘 + 제목 */}
                <Row style={{ alignItems: 'center', marginBottom: 8 }}>
                    <div
                        style={{
                            width: 28,
                            height: 28,
                            borderRadius: 8,
                            backgroundColor: '#EBF1FB',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: 10,
                            flexShrink: 0,
                        }}
                    >
                        <SvgIcon name="SvgLock" size={14} fill={colors.primary} stroke={colors.primary} />
                    </div>
                    <MediumText fontSize={14} lineHeight={20} color={colors.Text_1}>
                        탭 잠금 설정
                    </MediumText>
                </Row>

                {/* 설명 */}
                <DemiLightText fontSize={13} lineHeight={19} color="#8E9AA0" className="mb-[14px]">
                    민감한 데이터를 2차 비밀번호로 보호하세요. 센터 리포트, 매출 정산 등 원하는 탭에 잠금을 설정할 수 있어요.
                </DemiLightText>

                {/* 설정하기 버튼 */}
                <div
                    onClick={onClickSetup}
                    className="cursor-pointer flex items-center justify-center h-[36px] rounded-[8px] transition-opacity hover:opacity-90"
                    style={{ backgroundColor: colors.primary }}
                >
                    <MediumText fontSize={13} lineHeight={18} color="white">
                        설정하기
                    </MediumText>
                </div>
            </Col>

            {/* 애니메이션 keyframes */}
            <style>{`
                @keyframes fadeSlideIn {
                    from { opacity: 0; transform: translateY(-8px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

export default TabLockPromotionTooltip;
